import { useCallback } from 'react';
export function useMergedRef(...refs) {
  return useCallback(element => {
    for (const ref of refs) {
      if (typeof ref === 'function') {
        ref(element);
      } else if (ref && typeof ref === 'object') {
        ref.current = element;
      }
    }
  }, [refs]);
}